import { render } from "./ProjectAmounts.vue?vue&type=template&id=dabda6c4"
import script from "./ProjectAmounts.vue?vue&type=script&lang=js"
export * from "./ProjectAmounts.vue?vue&type=script&lang=js"

import "./ProjectAmounts.vue?vue&type=style&index=0&id=dabda6c4&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__